import { render } from "./MasterDataModal.vue?vue&type=template&id=1ebd046a&scoped=true"
import script from "./MasterDataModal.vue?vue&type=script&lang=js"
export * from "./MasterDataModal.vue?vue&type=script&lang=js"

import "./MasterDataModal.vue?vue&type=style&index=0&id=1ebd046a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebd046a"]])

export default __exports__